module.exports = __webpack_public_path__ + "img/jovens-talentos-thumb.18b8d8f1.jpg";